import logo from "./logo.svg";
import "./App.css";
import { Space, Typography } from "antd";
import Search from "./components/search";
//import Result from './components/result';
import { useState } from "react";
import Product from "./components/Product";
import Selector from "./components/selector";

const { Title } = Typography;

export default function App() {
  const [response, setResponse] = useState(null);

  const handleResponse = (childdata) => {
    console.log(childdata.name);
    setResponse(
      <Product
        name={childdata.name}
        image={childdata.image}
        brand={childdata.brand}
      />
    );
    //return (response)
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1 className="title">ColorMatch</h1>
      </header>
      <br />
      <br />
      <Selector/>
      <footer>
        <p>Made By Nikita Semenov</p>
      </footer>
    </div>
  );
}